angular.module('user', ['ui.bootstrap', 'ngResource', 'ui.select', 'ui.tinymce', 'angularMoment', 'daterangepicker', 'ui.bootstrap-slider',
    'toastr', 'language', 'pascalprecht.translate', 'user-group', 'identity', 'ui.router', 'account'])
    .factory('User', function ($resource) {
        return $resource('/crm/api/users/:id', {id: '@id'}, {
            autocomplete: {url: '/crm/api/users/autocomplete', method: 'get', isArray: true},
            register: {method: 'POST'},
            update: {method: 'PUT'},
            management: {method: 'GET', url: '/crm/api/users/:id/management'},
            table: {method: 'GET', isArray: false, url: '/crm/api/users/table'}
        })
    })
    .factory('Role', function ($resource) {
        return $resource('/crm/api/role', {}, {})
    })
    .factory('RoleCatalog', function ($resource) {
        return $resource('/crm/api/role/catalog', {}, {})
    })
    .factory('EnabledFeature', function ($resource) {
        return $resource('/crm/api/features/enabled', {}, {})
    })
    .factory('UserRoleSelectionService', function ($filter, User, UserService, toastr) {
        const normalizeText = value => (value || "")
            .toString()
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')

        const buildDependencyMap = modules => {
            const map = {}
            modules.forEach(module => (module.roles || []).forEach(role => {
                map[role.role] = role.dependsOn || []
            }))
            return map
        }

        const buildReverseDependencyMap = dependencyMap => {
            const reverseMap = {}
            Object.keys(dependencyMap).forEach(role => {
                (dependencyMap[role] || []).forEach(dependency => {
                    if (!Array.isArray(reverseMap[dependency])) {
                        reverseMap[dependency] = []
                    }
                    reverseMap[dependency].push(role)
                })
            })
            return reverseMap
        }

        return {
            initScope: $scope => {
                $scope.roleCatalog = []
                $scope.enabledModules = []
                $scope.enabledModulesLoaded = false
                $scope.enabledModulesLoadError = false
                $scope.roleDependencyMap = {}
                $scope.roleReverseDependencyMap = {}
                $scope.ui = {roleSearch: ""}

                const ensureRolesArray = () => {
                    if (!$scope.item) {
                        $scope.item = {}
                    }
                    if (!Array.isArray($scope.item.roles)) {
                        $scope.item.roles = []
                    }
                }

                const addRoleWithDependencies = (role, visited) => {
                    if (visited[role]) {
                        return
                    }
                    visited[role] = true
                    ensureRolesArray()
                    if ($scope.item.roles.indexOf(role) === -1) {
                        $scope.item.roles.push(role)
                    }
                    const dependencies = $scope.roleDependencyMap[role] || []
                    dependencies.forEach(dep => addRoleWithDependencies(dep, visited))
                }

                const removeRoleWithDependents = (role, visited) => {
                    if (visited[role]) {
                        return
                    }
                    visited[role] = true
                    ensureRolesArray()
                    $scope.item.roles = $scope.item.roles.filter(selectedRole => selectedRole !== role)
                    const dependents = $scope.roleReverseDependencyMap[role] || []
                    dependents.forEach(dependentRole => removeRoleWithDependents(dependentRole, visited))
                }

                const translateRole = role => ($filter("translate")("roles." + role) || role || "").toString()
                const roleLabel = role => normalizeText(translateRole(role))
                const roleItemComparator = (a, b) => {
                    const labelCompare = translateRole(a.role).localeCompare(translateRole(b.role), 'pl', {sensitivity: 'base'})
                    return labelCompare !== 0 ? labelCompare : a.role.localeCompare(b.role)
                }

                const sortRoleCatalog = catalog => catalog.map(module => angular.extend({}, module, {
                    roles: (module.roles || []).slice().sort(roleItemComparator)
                }))

                $scope.isRoleSelected = role => {
                    ensureRolesArray()
                    return $scope.item.roles.indexOf(role) !== -1
                }

                $scope.toggleRole = role => {
                    ensureRolesArray()
                    const idx = $scope.item.roles.indexOf(role)
                    if (idx !== -1) {
                        removeRoleWithDependents(role, {})
                        return
                    }
                    addRoleWithDependencies(role, {})
                }

                $scope.getVisibleRoles = module => {
                    const query = normalizeText($scope.ui.roleSearch).trim()
                    if (!query) {
                        return module.roles || []
                    }
                    return (module.roles || []).filter(roleItem => {
                        const roleName = normalizeText(roleItem.role)
                        return roleName.indexOf(query) !== -1 || roleLabel(roleItem.role).indexOf(query) !== -1
                    })
                }

                $scope.hasVisibleRoles = module => $scope.getVisibleRoles(module).length > 0
                $scope.getVisibleModules = () => ($scope.roleCatalog || []).filter(module => $scope.hasVisibleRoles(module))

                $scope.countSelectedInModule = module => (module.roles || []).filter(roleItem => $scope.isRoleSelected(roleItem.role)).length

                const openModulesBySelection = () => {
                    if (!$scope.roleCatalog.length) {
                        return
                    }
                    const anySelected = Array.isArray($scope.item && $scope.item.roles) && $scope.item.roles.length > 0
                    $scope.roleCatalog.forEach((module, index) => {
                        const selectedInModule = $scope.countSelectedInModule(module)
                        module.open = anySelected ? selectedInModule > 0 : index === 0
                    })
                }

                const replaceRoles = roles => {
                    $scope.item.roles = angular.copy(angular.isArray(roles) ? roles : [])
                    openModulesBySelection()
                }

                $scope.loadRolesFromUser = () => {
                    return UserService.pickUserModal().then(sourceUser => {
                        if (!sourceUser || !sourceUser.id) {
                            return
                        }
                        if (angular.isDefined($scope.item.id) && $scope.item.id !== null && String(sourceUser.id) === String($scope.item.id)) {
                            toastr.warning("Wybierz innego użytkownika")
                            return
                        }
                        return User.get({id: sourceUser.id}).$promise.then(user => {
                            replaceRoles(user.roles)
                            toastr.success("Wczytano uprawnienia użytkownika")
                        }).catch(() => {
                            toastr.error("Nie udało się wczytać uprawnień użytkownika")
                        })
                    }).catch(angular.noop)
                }

                $scope.clearRoles = () => {
                    replaceRoles([])
                }

                $scope.clearRoleFilter = () => {
                    $scope.ui.roleSearch = ""
                    openModulesBySelection()
                }

                $scope.$watch('ui.roleSearch', () => {
                    const query = normalizeText($scope.ui.roleSearch).trim()
                    if (!query) {
                        openModulesBySelection()
                        return
                    }
                    $scope.roleCatalog.forEach(module => {
                        module.open = $scope.hasVisibleRoles(module)
                    })
                })

                return {
                    ensureRolesArray: ensureRolesArray,
                    openModulesBySelection: openModulesBySelection,
                    applyEnabledModules: features => {
                        $scope.enabledModules = Array.isArray(features) ? features : []
                        $scope.enabledModulesLoaded = true
                    },
                    applyRoleCatalog: catalog => {
                        $scope.roleCatalog = Array.isArray(catalog) ? sortRoleCatalog(catalog) : []
                        $scope.roleDependencyMap = buildDependencyMap($scope.roleCatalog)
                        $scope.roleReverseDependencyMap = buildReverseDependencyMap($scope.roleDependencyMap)
                        $scope.roles = $scope.roleCatalog.reduce((all, module) => all.concat((module.roles || []).map(role => role.role)), [])
                        openModulesBySelection()
                    }
                }
            }
        }
    })
    .service('UserService', function ($rootScope, $http, $location, $q, Identity, User, modals, toastr, Auth, Account) {
        let userSearchModalOpen = false
        const openUserPickerModal = () => modals.open('app/user/search-modal.html', 'UserSearchModalController', {}, {
            size: 'md',
            windowClass: 'dialogs-default user-search-modal'
        }, "$ctrl")

        this.userProfile = (user) => {
            if (!user || !user.id) {
                return
            }
            return User.get({id: user.id}).$promise
                .then(
                    item => modals.open('app/user/profile-modal.html', 'UserProfileModalController', item, {size: 'md'}, "$ctrl"),
                    () => modals.open('app/user/profile-modal.html', 'UserProfileModalController', user, {size: 'md'}, "$ctrl")
                )
        }
        this.searchUserModal = () => {
            if (userSearchModalOpen) {
                return
            }

            userSearchModalOpen = true
            return openUserPickerModal()
                .then(user => this.userProfile(user))
                .finally(() => userSearchModalOpen = false)
        }
        this.pickUserModal = () => openUserPickerModal()
        this.editModal = id => modals.open('app/user/register-user-modal.tpl.html', 'UserDialogController', {id: id}, {size: 'lg'})
        this.registerUserModal = () => {
            let entity = {
                id: null,
                activated: true,
                sendEmailConfirmation: true,
                roles: []
            }
            return modals.open('app/user/register-user-modal.tpl.html', 'UserRegistrationDialogController', entity, {size: 'lg'})
        }
        this.remove = item => {
            return modals.confirmDelete(item.fullName, () => User.delete({id: item.id}).$promise.then(() => $rootScope.$broadcast('user.updated')))
        }
        this.logAsUserModal = item => {
            let content = "Czy chcesz zalogować się jako użytkownik <strong>" + item.fullName + "</strong>?"
            return modals.confirm(content, () => Auth.loginAs(item.login, () => $location.path("/")))
        }
        this.resetPasswordSendEmail = user => {
            modals.confirm("Czy chcesz wysłać email z linkiem do resetu hasła dla użytkownika <strong>" + user.fullName + "</strong>?", () => Account.resetRequest({email: user.email}))
        }
    })
    .controller('UserProfileModalController', function ($uibModalInstance, data, UserService) {
        this.item = data
        this.cancel = () => $uibModalInstance.dismiss('Canceled')
        this.edit = () => {
            if (!this.item || !this.item.id) {
                return
            }
            $uibModalInstance.dismiss('edit')
            return UserService.editModal(this.item.id)
        }
    })
    .controller('UserSearchModalController', function ($uibModalInstance) {
        this.select = user => {
            if (user && user.id) {
                $uibModalInstance.close(user)
            }
        }
        this.cancel = () => $uibModalInstance.dismiss('Canceled')
    })
    .controller('UserRegistrationDialogController', function ($scope, $rootScope, $uibModalInstance, data, toastr, User, RoleCatalog, EnabledFeature, UserRoleSelectionService, Principal) {
        $scope.item = data
        $scope.userLoadPending = false
        $scope.roleCatalogLoadError = false
        const roleSelection = UserRoleSelectionService.initScope($scope)
        roleSelection.ensureRolesArray()

        RoleCatalog.query().$promise.then(result => {
            roleSelection.applyRoleCatalog(result)
        }).catch(() => {
            $scope.roleCatalogLoadError = true
            toastr.error("Nie udało się wczytać katalogu ról")
        })
        EnabledFeature.query().$promise.then(result => {
            roleSelection.applyEnabledModules(result)
        }).catch(() => {
            $scope.enabledModulesLoadError = true
            toastr.error("Nie udało się wczytać listy włączonych modułów")
        })

        $scope.cancel = () => $uibModalInstance.dismiss('Canceled')

        $scope.save = () => {
            return User.register($scope.item).$promise.then(result => {
                $rootScope.$broadcast('user.updated')
                Principal.refreshIdentity()
                $uibModalInstance.close(result)
                toastr.success("Zapisano")
            })
        }

        $scope.$watch('createPassword', function (newVal, oldVal) {
            if (newVal !== oldVal && newVal === false) {
                $scope.item.password = ""
            }
        })
    })
    .controller('UserDialogController', function ($scope, $rootScope, $uibModalInstance, data, toastr, User, RoleCatalog, EnabledFeature, UserRoleSelectionService, UserService, Principal) {

        $scope.item = {roles: []}
        $scope.userLoadPending = true
        $scope.roleCatalogLoadError = false
        const roleSelection = UserRoleSelectionService.initScope($scope)

        User.management(data).$promise.then(result => {
            $scope.item = result
            roleSelection.ensureRolesArray()
            roleSelection.openModulesBySelection()
        }).finally(() => {
            $scope.userLoadPending = false
        })
        RoleCatalog.query().$promise.then(result => {
            roleSelection.applyRoleCatalog(result)
        }).catch(() => {
            $scope.roleCatalogLoadError = true
            toastr.error("Nie udało się wczytać katalogu ról")
        })
        EnabledFeature.query().$promise.then(result => {
            roleSelection.applyEnabledModules(result)
        }).catch(() => {
            $scope.enabledModulesLoadError = true
            toastr.error("Nie udało się wczytać listy włączonych modułów")
        })

        $scope.cancel = () => $uibModalInstance.dismiss('Canceled')

        $scope.loginAsUser = () => {
            if (!$scope.item || !$scope.item.id) {
                return
            }
            return UserService.logAsUserModal($scope.item)
                .then(() => $uibModalInstance.close($scope.item))
                .catch(() => {
                })
        }

        $scope.save = () => {
            return User.update($scope.item).$promise.then(result => {
                $rootScope.$broadcast('user.updated')
                Principal.refreshIdentity()
                $uibModalInstance.close(result)
                toastr.success("Zapisano")
            })
        }

        $scope.$watch('createPassword', (newVal, oldVal) => {
            if (newVal !== oldVal && newVal === false) {
                $scope.item.password = ""
            }
        })
    })
    .component('userListView', {
        bindings: {
            filters: '<',
            page: '<'
        },
        templateUrl: 'app/user/list.html',
        controller: function ($scope, $http, $state, $filter, $timeout, Account, Role, RoleCatalog, UserService, SharedCalendarService) {
            this.UserService = UserService
            this.SharedCalendarService = SharedCalendarService

            this.reset = () => this.filters = {}
            this.roleModules = []
            this.roleToModuleKey = {}

            this.hasRoles = item => Array.isArray(item && item.roles) && item.roles.length > 0

            const translateRole = role => ($filter('translate')('roles.' + role) || role || '').toString()
            const roleComparator = (leftRole, rightRole) => translateRole(leftRole).localeCompare(translateRole(rightRole), 'pl', {sensitivity: 'base'})
            let modulePopoverClosePromise = null
            let allRolesPopoverClosePromise = null
            const closeAllRolePopovers = () => {
                const userItems = (this.page && this.page.list) || []
                userItems.forEach(userItem => {
                    userItem._isAllRolesPopoverOpen = false
                    ;(userItem._modulePreviewRows || []).forEach(moduleRow => moduleRow._isModulePopoverOpen = false)
                })
            }

            this.openModuleRolesPopover = (item, module) => {
                closeAllRolePopovers()
                if (module) {
                    module._isModulePopoverOpen = true
                }
                if (item) {
                    item._isAllRolesPopoverOpen = false
                }
            }

            this.cancelCloseModuleRolesPopover = () => {
                if (modulePopoverClosePromise) {
                    $timeout.cancel(modulePopoverClosePromise)
                    modulePopoverClosePromise = null
                }
            }

            this.scheduleCloseModuleRolesPopover = module => {
                this.cancelCloseModuleRolesPopover()
                modulePopoverClosePromise = $timeout(() => {
                    if (module) {
                        module._isModulePopoverOpen = false
                    }
                }, 150)
            }

            this.closeModuleRolesPopover = module => {
                this.cancelCloseModuleRolesPopover()
                if (module) {
                    module._isModulePopoverOpen = false
                }
            }

            this.cancelCloseAllRolesPopover = () => {
                if (allRolesPopoverClosePromise) {
                    $timeout.cancel(allRolesPopoverClosePromise)
                    allRolesPopoverClosePromise = null
                }
            }

            this.scheduleCloseAllRolesPopover = item => {
                this.cancelCloseAllRolesPopover()
                allRolesPopoverClosePromise = $timeout(() => {
                    if (item) {
                        item._isAllRolesPopoverOpen = false
                    }
                }, 150)
            }

            this.closeAllRolesPopover = item => {
                this.cancelCloseAllRolesPopover()
                if (item) {
                    item._isAllRolesPopoverOpen = false
                }
            }

            this.openAllRolesPopover = (item, module, $event) => {
                if ($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                }
                closeAllRolePopovers()
                if (module) {
                    module._isModulePopoverOpen = false
                }
                if (item) {
                    item._isAllRolesPopoverOpen = true
                }
            }

            const buildRoleCatalogIndex = catalog => {
                this.roleModules = (catalog || []).map(module => ({key: module.key}))
                this.roleToModuleKey = {}
                ;(catalog || []).forEach(module => (module.roles || []).forEach(roleItem => {
                    this.roleToModuleKey[roleItem.role] = module.key
                }))
            }

            const buildPageRolePresentation = () => {
                const userItems = (this.page && this.page.list) || []
                userItems.forEach(item => {
                    const sortedRoles = (item.roles || []).slice().sort(roleComparator)

                    const groupedRoles = {}
                    sortedRoles.forEach(role => {
                        const moduleKey = this.roleToModuleKey[role] || 'OTHER'
                        if (!Array.isArray(groupedRoles[moduleKey])) {
                            groupedRoles[moduleKey] = []
                        }
                        groupedRoles[moduleKey].push(role)
                    })

                    const orderedKnownModuleKeys = this.roleModules
                        .map(module => module.key)
                        .filter(moduleKey => Array.isArray(groupedRoles[moduleKey]))
                    const unknownModuleKeys = Object.keys(groupedRoles)
                        .filter(moduleKey => orderedKnownModuleKeys.indexOf(moduleKey) === -1)
                        .sort((left, right) => left.localeCompare(right, 'pl', {sensitivity: 'base'}))
                    const orderedModuleKeys = orderedKnownModuleKeys.concat(unknownModuleKeys)

                    item._roleModules = orderedModuleKeys.map(moduleKey => ({
                        key: moduleKey,
                        roles: groupedRoles[moduleKey]
                    }))
                    item._modulePreviewRows = item._roleModules.map(module => ({
                        key: module.key,
                        count: module.roles.length,
                        roles: module.roles
                    }))
                })
            }

            this.$onInit = () => {
                Account.safeZoneSuperAdmin().$promise.then(response => {
                    this.isInSafeZone = response.safeZone
                    this.canLogInAsOtherUser = this.isInSafeZone
                })
                Role.query().$promise.then(result => this.roles = result)
                RoleCatalog.query().$promise.then(result => {
                    buildRoleCatalogIndex(result)
                    buildPageRolePresentation()
                })
                buildPageRolePresentation()
            }
            this.$onChanges = () => buildPageRolePresentation()

            $scope.$on('user.updated', () => $state.reload())
        }
    })
    .config(function ($stateProvider) {
        $stateProvider.state('userList', {
            parent: 'app',
            url: '/users?{page:int}&{size:int}&sort&search&role&module&active',
            params: {
                active: "active"
            },
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_USER_MANAGEMENT']
            },
            views: {
                'content@': 'userListView'
            },
            resolve: {
                filters: $stateParams => angular.copy($stateParams),
                page: (User, $stateParams) => User.table(angular.copy($stateParams)).$promise
            }
        })
    })
